import { render, staticRenderFns } from "./study-list.vue?vue&type=template&id=17ca5dd2&scoped=true&"
import script from "./study-list.vue?vue&type=script&lang=ts&"
export * from "./study-list.vue?vue&type=script&lang=ts&"
import style0 from "./study-list.vue?vue&type=style&index=0&id=17ca5dd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ca5dd2",
  null
  
)

export default component.exports